// ----------------------------
// Virtual Market
// ----------------------------

// ------------------------------------
// Imports
// ------------------------------------
import { put, call, takeLatest } from 'redux-saga/effects';

import {
    GET_TOKEN_USER,
    getTokenUserSucceeded,
    getTokenUserFailed,
    setUserSessionTime,
    REQUEST_RECOVER_USER,
    recoverUserSucceeded,
    recoverUserFailed,
    validTokenSucceeded, validTokenFailed, VALID_TOKEN_RECOVERY, CHANGE_PASSWORD,
    chengePasswordSucceeded, chengePasswordFailed,
    REQUEST_CONFIRMATION_EMAIL, requestConfirmationEmailFailed, requestConfirmationEmailSucceeded,
    finishShopping, setCart, setProducts
} from '../modules/module_user';
import {
    getTokenSucceeded, setUserSessionData, setLastPathSuccess, setStartHour, setEndHour, setCampaign, setAceptabilidad
  } from '../modules/module_settings.js'

import { initializeSettingsStorage, updateSettingsStorage, initializeMetricsStorage,
     initializeMarketStorage, initializeSocioQuestionnaireStorage, defineLastPathToRedirect,
     initializeExitQuestionnaireStorage, initializeProductsStorage, initializeSummaryStorage, updateSummaryStorage,
     updateMarketStorage, updateExitQuestionnaireStorage, updateProductsStorage, guardarEstadoCuestionarios } from 'utilities/session-utils'
import { getQuestions, getQuestionsSucceeded, getQuestionsFailed, asignarEstadoCuestionarios } from '../modules/module_questions'
import { fetchProductsByMarket } from 'services/products-api'
import { fetchQuestions } from 'services/question-api'
import { setProducts as setProductsSalida, setAnswersSalida, setProductsInCart } from '../../routes/Home/routes/VirtualMarket/routes/Summaries/modules/module-summaries';

import { API_REQUEST_STATUS_SUCCEEDED, API_REQUEST_STATUS_FAILED } from 'services/config'
import { doCallback, addImagesToProducts, applyImagesToProductsInCart, matchAnswersQuestionnaireSalida, getProductsByDepartment } from 'utilities/general-utils'
import protocols from 'common-protocols'

// ------------------------------------
// Services
// ------------------------------------
import { getTokenUser, requestRecoverUser, requestValidToken, changePassword, requestConfirmationEmail } from 'services/user-api'


// ------------------------------------
// Sagas
// ------------------------------------

/* Sagas - Workers */
function* getTokenUserRequested({username, password}) {
    const result = yield call(getTokenUser, {username, password});
    let actionToDo = null;
    let message = API_REQUEST_STATUS_FAILED;
    console.log(result);
    if(!!result.response) {
        console.log(result.response.data);
        const { token, sesion, mercado, combinacion, monto, 
            ruta, usuario, ticket, productsInCart, mensaje, resultados, departamentos, idPais, campaign, acpetabilidad } = result.response.data;
        const start = new Date();
        let end = new Date();
        end.setMilliseconds(3630000);

        if (usuario && usuario.rol === protocols.ADMINISTRATOR) {
            //USUARIO ADMINISTRADOR
        } else {
            initializeSettingsStorage([token], start, end);
            initializeMetricsStorage();
            initializeMarketStorage();
            initializeSocioQuestionnaireStorage();
            initializeExitQuestionnaireStorage();
            initializeProductsStorage();
            initializeSummaryStorage();
            if (ticket) {
                updateSettingsStorage(ticket, 'ticket');
                updateSettingsStorage(!!ticket, 'hasTicket');
            }
            updateSettingsStorage(mercado, 'idMarket');
            updateSettingsStorage(sesion, 'idSession');
            updateSettingsStorage(combinacion, 'combinacion');
            updateSettingsStorage(Number(monto), 'startingMoney');

            updateSettingsStorage(idPais, 'idPais');
            updateSettingsStorage(campaign, 'campaign');

            const questions = yield call(fetchQuestions, token);
            if(questions.response.data){
                console.log(questions.response.data)
                yield put(getQuestionsSucceeded(questions.response.data[0], questions.response.data[1], questions.response.data[2], questions.response.data[3], questions.response.data[4], questions.response.data[5]));
                const estadoCuestionarios = {
                    inclusion: questions.response.data[0].activo,
                    socioBasico: questions.response.data[1].activo,
                    salida: questions.response.data[2].activo,
                    socioCampana: questions.response.data[3].activo,
                    menosSaludable: questions.response.data[4].activo,
                    salidaCampaign: questions.response.data[5].activo
                }
                yield put(asignarEstadoCuestionarios(estadoCuestionarios));
                guardarEstadoCuestionarios(estadoCuestionarios);
            }


            message = API_REQUEST_STATUS_SUCCEEDED;
            if (ruta === 'SocioDemografico') {
                updateSettingsStorage('/mercado_virtual/prueba/cuestionario_sociodemografico', 'navigation.path');
            } else if( ruta === 'Asentimiento'){
                const products = yield call(fetchProductsByMarket, token, mercado, idPais);
                let updatedProducts = [];
                if (products.response) {
                    updatedProducts = addImagesToProducts(products.response.data, mercado, idPais);
                }
                const cartWithImages = applyImagesToProductsInCart(productsInCart, updatedProducts);
                updateMarketStorage(cartWithImages, "productsInCart");
                yield put(setCart(cartWithImages));
                updateSettingsStorage(defineLastPathToRedirect(ruta), 'navigation.path');

            } else if(ruta === "MenosSaludable" && campaign === 1){
                updateSettingsStorage(defineLastPathToRedirect(ruta), 'navigation.path');
            } else if(ruta === 'ResumenCompra'){
                const products = yield call(fetchProductsByMarket, token, mercado, idPais);
                let updatedProducts = [];
                if (products.response) {
                    updatedProducts = addImagesToProducts(products.response.data, mercado);
                }
                const cartWithImages = applyImagesToProductsInCart(productsInCart, updatedProducts);
                updateMarketStorage(cartWithImages, "productsInCart");
                yield put(setCart(cartWithImages));
                yield put(finishShopping());
                updateMarketStorage(mensaje, 'finishPurchase');
                updateSettingsStorage(defineLastPathToRedirect(ruta), 'navigation.path');

            } else if(ruta === "CuestionarioSalida" || ruta === "CuestionarioCampana"){
                // todo solicitar productos
                
                const products = yield call(fetchProductsByMarket, token, mercado, idPais);
                let updatedProducts = [];
                if (products.response) {
                    updatedProducts = addImagesToProducts(products.response.data, mercado);
                }
                const cartWithImages = applyImagesToProductsInCart(productsInCart, updatedProducts);
                updateMarketStorage(cartWithImages, "productsInCart");
                const updatedProductsByDepartment = getProductsByDepartment(products.response.data, true, mercado);
                yield put(setProducts(updatedProductsByDepartment));
                yield put(setCart(cartWithImages));
                yield put(finishShopping());
                updateProductsStorage(departamentos, 'products');
                
                updateExitQuestionnaireStorage(resultados, 'answers');
                
                if(mercado !== 4 && campaign === 1 && ruta === "CuestionarioSalida"){
                    updateExitQuestionnaireStorage(1, 'step');
                }

                updateMarketStorage(mensaje, 'finishPurchase');
                updateSettingsStorage(defineLastPathToRedirect(ruta), 'navigation.path');
            } else if(ruta === "Resumen"){
                // Productos
                const products = yield call(fetchProductsByMarket, token, mercado, idPais);
                let updatedProducts = [];
                if (products.response) {
                    updatedProducts = addImagesToProducts(products.response.data, mercado);
                }
                const cartWithImages = applyImagesToProductsInCart(productsInCart, updatedProducts);
                updateMarketStorage(cartWithImages, "productsInCart");
                const updatedProductsByDepartment = getProductsByDepartment(products.response.data, true, mercado);
                yield put(setProductsSalida(updatedProductsByDepartment));
                yield put(setCart(cartWithImages));
                yield put(setProductsInCart(cartWithImages));
                yield put(finishShopping());
                
                departamentos.beverages = obtenerProductoParaRespuesta(updatedProductsByDepartment.beverages, resultados[10], departamentos.beverages);
                departamentos.snacks = obtenerProductoParaRespuesta(updatedProductsByDepartment.snacks, resultados[11], departamentos.snacks);
                departamentos.cereals = obtenerProductoParaRespuesta(updatedProductsByDepartment.cereals, resultados[12], departamentos.cereals);
                departamentos.dairyProducts = obtenerProductoParaRespuesta(updatedProductsByDepartment.dairyProducts, resultados[13], departamentos.dairyProducts);
                departamentos.readyToEat = obtenerProductoParaRespuesta(updatedProductsByDepartment.readyToEat, resultados[14], departamentos.readyToEat);
                const productosParaQuiz = [
                    [...departamentos.beverages],
                    [...departamentos.snacks],
                    [...departamentos.cereals],
                    [...departamentos.dairyProducts],
                    [...departamentos.readyToEat],
                ]
                updateProductsStorage(productosParaQuiz, 'products');
                
                updateExitQuestionnaireStorage(resultados, 'answers');

                updateMarketStorage(mensaje, 'finishPurchase');
                updateSettingsStorage(defineLastPathToRedirect(ruta), 'navigation.path');
            } else {
                updateSettingsStorage(defineLastPathToRedirect(ruta), 'navigation.path');
            }
        }
        yield put(getTokenUserSucceeded({token, ruta, usuario}));
        yield put(getTokenSucceeded(token));
        yield put(setUserSessionData({
            idSession: sesion,
            idMarket: mercado,
            combinacion
        }));
        yield put(setUserSessionTime({
            startingTime: start,
            endingTime: end
        }));
        yield put(setStartHour(start));
        yield put(setEndHour(end));
        yield put(setLastPathSuccess(ruta));

        yield put(setCampaign(idPais, campaign));
        updateSettingsStorage(acpetabilidad, "aceptabilidad")
        yield put(setAceptabilidad(acpetabilidad));
        updateSettingsStorage(ruta, 'lastPath');
    } else {
        message = result.error.response.data;
        yield put(getTokenUserFailed({error: result.error, message}));
    }

    
}

function* recoverUserRequested({username}){
    const { error, response } = yield call(requestRecoverUser, username);

    if(response) {
        yield put(recoverUserSucceeded(true));
    } else {
        yield put(recoverUserFailed(error));
    }
}

function* recoverValidToken(action){
    const { error, response } = yield call(requestValidToken, action);

    let message = API_REQUEST_STATUS_FAILED;

    if(response) {
        message = "OK";
        yield put(validTokenSucceeded(response));
    } else {
        message = error.request.response;
        yield put(validTokenFailed(error));
    }

    if (action.callback){
        doCallback(action.callback, message, response);
    }
}

function* recoverChangePassword(action){
    const { error, response } = yield call(changePassword, action);

    let message = API_REQUEST_STATUS_FAILED;
    console.log(error);
    console.log(response);

    if(!!response.data) {
        message = "OK";
        yield put(chengePasswordSucceeded(response));
    } else {
        message = error.request.response;
        yield put(chengePasswordFailed(error));
    }

    if (action.callback){
        doCallback(action.callback, message, response);
    }
}

function* requestEmail({email}){
    const {error, response} = yield call(requestConfirmationEmail, email);
    console.log(error);
    console.log(response);
    if(response){
        yield put (requestConfirmationEmailSucceeded());
    } else{
        yield put (requestConfirmationEmailFailed());
    }
}


/* Sagas - Watchers/Listeners */
export function* watchGetTokenUser() {
    yield takeLatest(GET_TOKEN_USER, getTokenUserRequested);
}

export function* watchRecoverUser(){
    yield takeLatest(REQUEST_RECOVER_USER, recoverUserRequested)
}

export function* watchRecoverValidToken(){
    yield takeLatest(VALID_TOKEN_RECOVERY, recoverValidToken)
}

export function* watchChangePassword(){
    yield takeLatest(CHANGE_PASSWORD, recoverChangePassword)
}

export function* watchRequestConfirmationEmail(){
    yield takeLatest(REQUEST_CONFIRMATION_EMAIL, requestEmail);
}

// ------------------------------------
// Exports Functions
// ------------------------------------

export const userSagas = [
    watchGetTokenUser,
    watchRecoverUser,
    watchChangePassword,
    watchRecoverValidToken,
    watchRequestConfirmationEmail
];





function obtenerProductoParaRespuesta(productos, respuesta, listaAAgregar){
    const producto = productos.find(pr => pr.idProducto == respuesta.answersSelected[0].valor && pr.idProducto !== listaAAgregar[0].idProducto)
    if(!!producto){
        listaAAgregar.push(producto);
    }
    return listaAAgregar;
}


// WEBPACK FOOTER //
// ./src/store/sagas/sagas_user.js